import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import Select from 'react-select';
import "./reports.css"
import { BarLoader } from 'react-spinners';
import moment from 'moment';
import { BsFiletypeCsv } from "react-icons/bs";
import { SiMicrosoftexcel } from "react-icons/si";
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import Pagination from '../pagination/pagination';
import { toast } from 'react-toastify';
import { PiDownloadSimple } from "react-icons/pi";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useCurrency } from '../../Layouts/currencyContext';
import * as XLSX from "xlsx";
import Table from 'react-bootstrap/Table';
import { Fragment } from 'react';

const POAnalysis = () => {
    const apiService = new ApiService();
    const [rowData, setRowData] = useState([]);
    const [allData, setallData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [StockType, setStockType] = useState();
    const [SupplierList, setSuppliers] = useState();
    const { currencyPrecision } = useCurrency();
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const getCurrentLocalDatetime = () => {
        const localDate = new Date();
        const offset = localDate.getTimezoneOffset() * 60000;
        const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
        return localISOTime;
    };
    const [toDate, setToDate] = useState(getCurrentLocalDatetime);
    const [fromDate, setFromDate] = useState(getCurrentLocalDatetime);
    const [dateFilter, setdateFilter] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const [formData, setFormData] = useState({
        startdate: getCurrentLocalDatetime(),
        endDate: getCurrentLocalDatetime(),
        VendorName: [{ label: 'Select Supplier ', value: '0' }],
        Items: [{ label: 'Select PO', value: '0' }],
    });
    const handleClearFilters = () => {
        setFormData({
            startdate: getCurrentLocalDatetime(),
            endDate: getCurrentLocalDatetime(),
            VendorName: [{ label: 'Select Supplier ', value: '0' }],
            Items: [{ label: 'Select PO', value: '0' }],
        });
        setFromDate(getCurrentLocalDatetime)
        setToDate(getCurrentLocalDatetime)
        setdateFilter(false)
    };
    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const params = new URLSearchParams();
                params.append('dropdownTypes', 'PoAnalysisReportsSuppliers,PoAnalysisReportsPoNos');
                const res = await apiService.getApiParamater('ANALYSIS_DDLS', `?${params.toString()}`);
                setStockType(res?.data?.dropdowns?.PoAnalysisReportsPoNos);
                setSuppliers(res?.data?.dropdowns?.PoAnalysisReportsSuppliers);
            } catch (error) {
                console.error('Error fetching dropdown data:', error);
            }
        };
        fetchDropdownData();
        getItems()
    }, []);
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('Vendor', formData.VendorName.label || "All");
            params.append('POrderNo', formData?.Items?.label || "All");
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            params.append('FromDate', fromDate || "");
            params.append('ToDate', toDate || "");
            const res = await apiService.getApiParamater('GET_ANALYSIS', `?${params.toString()}`);
            setRowData(res?.data?.result?.reverse() || []);
            setPagination(res.data.paginationData);
            setLoading(false);

            params.append('PageSize', res.data.paginationData?.totalRecords ?? 10000);
            const allRes = await apiService.getApiParamater('GET_ANALYSIS', `?${params.toString()}`);
            const allData = allRes?.data?.result ?? [];
            setallData(allData)
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const handleStockChange = (selectedOption) => {
        setFormData({ ...formData, StockType: selectedOption });
    }
    const handleSupplierChange = async (selectedOption) => {
        const params = new URLSearchParams();
        params.append('DropdownFor', "PoAnalysisPoNosBySuppId");
        params.append('CascadValue', selectedOption?.value?.value || "");
        const res = await apiService.getApiParamater('ANALYSIS_CASCAD', `?${params.toString()}`);
        setStockType(res?.data?.items);
        setFormData({ ...formData, VendorName: selectedOption });
    }
    const handleFromDate = (e) => {
        setFromDate(e.target.value);
    };
    const handleToDate = (e) => {
        setToDate(e.target.value);
    };
    const handleDateFilterSelection = (e) => {
        setdateFilter(e);
    };
    const comparisonExportConfig = [
        { header: 'Supplier Name', key: 'vendorName', width: 25 },
        { header: 'Supplier ID', key: 'vendorId', width: 15 },
        { header: 'Requisition No', key: 'requisitionNo', width: 20 },
        { header: 'Requisition Date', key: 'requisitionDate', type: 'date', width: 18 },
        { header: 'Requestor', key: 'requestor', width: 20 },
        { header: 'POrder No', key: 'porderNo', width: 18 },
        { header: 'PO Date', key: 'poDate', type: 'date', width: 18 },
        { header: 'PO Amount', key: 'poAmount', type: 'amount', width: 15 },
        { header: 'GRN No', key: 'grnNo', width: 18 },
        { header: 'GRN Date', key: 'grnDate', type: 'date', width: 18 },
        { header: 'GRN Amount', key: 'grnAmount', type: 'amount', width: 15 },
        { header: 'Invoice No', key: 'invoiceRegNo', width: 18 },
        { header: 'Invoice Date', key: 'invoiceDate', type: 'date', width: 18 },
        { header: 'Invoice Amount', key: 'invAmount', type: 'amount', width: 15 },
        { header: 'Amount Paid', key: 'amountPaid', type: 'amount', width: 15 },
        { header: 'Balance', key: 'balance', type: 'amount', width: 15 },
    ];
    const formatExportValue = (value, type) => {
        if (value === null || value === undefined || value === 0) return '';

        if (type === 'date') {
            return moment(value).isValid()
                ? moment(value).format('DD-MMM-YYYY')
                : '';
        }

        if (type === 'amount') {
            return Number(value).toFixed(currencyPrecision?.exp1 || 3);
        }

        return value;
    };
    const exportComparisonCSV = () => {
        if (!rowData?.length) {
            toast.info('No data found to export');
            return;
        }

        const headers = comparisonExportConfig.map(c => c.header).join(',');

        const rows = rowData.map(item =>
            comparisonExportConfig
                .map(c => `"${formatExportValue(item[c.key], c.type)}"`)
                .join(',')
        );

        const csvContent = [headers, ...rows].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'PO_Comparison.csv';
        link.click();

        toast.success('PO_Comparison.csv downloaded');
    };
    const exportComparisonExcel = () => {
        if (!rowData?.length) return;

        const excelData = rowData.map(item => {
            const row = {};
            comparisonExportConfig.forEach(col => {
                row[col.header] = formatExportValue(item[col.key], col.type);
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // Column widths
        worksheet['!cols'] = comparisonExportConfig.map(col => ({
            wch: col.width,
        }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'PO Comparison');

        XLSX.writeFile(workbook, 'PO_Comparison.xlsx');
    };
    const groupedData = Object.values(
        rowData.reduce((acc, row) => {
            const key = [
                row.vendorName,
                row.vendorId,
                row.requisitionNo,
                row.requisitionDate,
                row.porderNo,
                row.poDate,
                row.poAmount
            ].join('|');

            if (!acc[key]) {
                acc[key] = {
                    supplier: `${row.vendorName} (${row.vendorId})`,
                    requisitionNo: row.requisitionNo,
                    requisitionDate: row.requisitionDate,
                    porderNo: row.porderNo,
                    poDate: row.poDate,
                    poAmount: row.poAmount,
                    grnNos: []
                };
            }

            if (row.grnNo) {
                acc[key].grnNos.push(row.grnNo);
            }

            return acc;
        }, {})
    );


    useState(() =>
        Object.fromEntries(Object.keys(groupedData).map(k => [k, true]))
    );

    return (
        <div className='p-4'>
            <div className='gridBg m-0 row' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='col-12'>
                    <div className='row'>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.VendorName}
                                onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                                options={SupplierList?.map((sup) => ({ value: sup, label: sup?.text }))}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.StockType}
                                onChange={(selectedOption) => handleStockChange(selectedOption)}
                                options={StockType?.map((Stock) => ({ value: Stock, label: Stock?.text }))}
                            />
                        </div>
                        <div className='col gap-3 center'>
                            <input className="form-check-input"
                                type="checkbox"
                                id="dateFilter" style={{ width: "20px", height: "20px" }}
                                name="dateFilter"
                                checked={dateFilter}
                                onChange={(e) => handleDateFilterSelection(e.target.checked)} />
                            <label className=''>Date Filter</label>
                        </div>
                        <div className='col'>
                            <input
                                type='datetime-local'
                                className="form-Input w-100"
                                value={fromDate}
                                name="fromDate"
                                disabled={!dateFilter}
                                onChange={handleFromDate}
                                placeholder='From  Date '
                            />
                        </div>
                        <div className='col'>
                            <input
                                type='datetime-local'
                                disabled={!dateFilter}
                                className="form-Input w-100"
                                placeholder='To  Date '
                                value={toDate}
                                name="toDate"
                                onChange={handleToDate}
                            />
                        </div>
                    </div>
                </div>
                <div className='col-5 gap-5 d-flex mt-2'>
                    <div onClick={() => getItems()} className='mainbtnGry w-50 mt-2 flex-end gap-2'>
                        <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Search</div>
                    </div>
                    <div onClick={() => handleClearFilters()} className='mainbtnRed w-50 flex-end mt-2 gap-2'>
                        <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Reset</div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >Purchase Order Analysis</div>
                <div className='d-flex gap-3 end'>
                    <div className='mainbtnGry flex-end gap-2' >
                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                            <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
                                <PiDownloadSimple size={25} />
                            </DropdownToggle>
                            <DropdownMenu className='mt-3'>
                                <DropdownItem onClick={exportComparisonCSV} className='gap-3 d-flex center'>
                                    <BsFiletypeCsv /> <div>Export CSV</div>
                                </DropdownItem>

                                <DropdownItem onClick={exportComparisonExcel} className='gap-3 d-flex center'>
                                    <SiMicrosoftexcel /> <div>Export Excel</div>
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>
            </div>
            <div className='gridshad'>
                {loading === true ?
                    <div className="center p-5">
                        <BarLoader color="#6E5199" height={3} width={200} />
                    </div>
                    :
                    <Table bordered hover responsive className="custom-table shadow-sm">
                        <thead className="table-header">
                            <tr>
                                <th className="text-center">Supplier</th>
                                <th >Requisition No</th>
                                <th>Requisition Date</th>
                                <th className="text-end">PO No</th>
                                <th>PO Date</th>
                                <th>PO Amount</th>
                                <th className="text-start">GRN No</th>
                            </tr>
                        </thead>

                        <tbody>
                            {groupedData.map((row, index) => (
                                <tr key={index}>
                                    <td className="fw-semibold supplier-cell">
                                        {row.supplier}
                                    </td>
                                    <td style={{width:"150px"}}>{row.requisitionNo}</td>
                                    <td style={{width:"170px"}}>{moment(row.requisitionDate).format("DD-MMM-YYYY")}</td>
                                    <td className="fw-semibold">{row.porderNo}</td>
                                    <td  style={{width:"150px"}}>{row.poDate}</td>
                                    <td className="amount-cell"  style={{width:"150px"}}>
                                        {row.poAmount?.toFixed(3)}
                                    </td>
                                    <td>
                                        <div className="grn-badges">
                                            {row.grnNos.length > 0
                                                ? row.grnNos.map((g, i) => (
                                                    <span key={i} className="grn-badge">{g}</span>
                                                ))
                                                : <span className="text-muted">—</span>}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                }
                <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
        </div>
    );
};
export default POAnalysis;